// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"fq-z","selected":"gq-z"};